import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY
  || process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    'Supabase não configurado. Crie o arquivo .env com:\n' +
    'REACT_APP_SUPABASE_URL=https://xxxx.supabase.co\n' +
    'REACT_APP_SUPABASE_PUBLISHABLE_KEY=sb_publishable_xxx'
  );
}

export const supabase = supabaseUrl && supabaseKey
  ? createClient(supabaseUrl, supabaseKey)
  : null;
